import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientFormControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientUuid: string;
  appointmentUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: Array<any>;
  sortBy?: string;
  sortDirection?: string;
  searchString?: string;
  xTENANTID?: string;
  isPublic?: boolean;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientNewIntakeFormList = ({
  patientUuid,
  appointmentUuid,
  pagination,
  gridSorting,
  status = ["PENDING"],
  sortDirection,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  return useQuery({
    queryKey: [
      "patient-intake-form-list",
      pageIndex,
      pageSize,
      sortBy,
      patientUuid,
      appointmentUuid,
      sortDirection,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!patientUuid && enabled,
    queryFn: async () =>
      await new PatientFormControllerApi(getConfigObject())
        .getAllPatientForms(
          patientUuid,
          pageIndex, //page
          pageSize, //size
          sortBy,
          sortDirection, // sortDirection
          status,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
